import Vue from 'vue'
import Vuex from 'vuex'

import * as auth from './modules/auth'
import * as pedido from './modules/pedido';
import * as financeiro from './modules/financeiro';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loading: false,
    loadingTable: false
  },
  getters: {
    loading: state => state.loading,
    loadingTable: state => state.loadingTable
  },
  mutations: {
    setLoading (state, payload) {
      state.loading = payload
    },
    setLoadingTable (state, payload) {
      state.loadingTable = payload
    }
  },
  actions: {
    setLoading ({ commit }, payload) {
      commit('setLoading', payload)
    },
    setLoadingTable ({ commit }, payload) {
      commit('setLoadingTable', payload)
    }
  },
  modules: {
    auth,
    pedido,
    financeiro
  }
})
